<template>
  <div id="page">
      <Navbar :title="'New Internal Link'" :backBtn="'EditInternal'"/>
      <div class="page-content header-clear-medium padding-sides">
            <div class="travel-list-container" >
                <h2 class="bold center-text">New Internal Link</h2>
                <div class="divider divider-margins"></div>

                <form @submit.prevent="newLink">
                
                    <ui-textbox
                        help="The Title is used purely in the backend to ease management"
                        label="Title"
                        placeholder="Enter link title"
                        v-model="link.title"
                    ></ui-textbox>

                    <ui-textbox
                        help="The PowerBI url"
                        label="Url"
                        placeholder="Enter dashboard url"
                        v-model="link.link"
                    ></ui-textbox>
                    
                    <ui-textbox
                        help="The url of the Icon to show"
                        label="Icon"
                        placeholder="Enter Icon url"
                        v-model="link.icon"
                    ></ui-textbox>

                    <ui-switch v-model="live" switch-position="right" style="padding-bottom: 20px">Live</ui-switch>

                    <p class="feedback" v-if="feedback">{{ feedback }}</p>
                    <div class="clear"></div>
                    <div class="center-allign">
                        <ui-button color="primary" :loading="loading" >Add</ui-button>
                    </div>
                    
                </form>

            </div>
        </div>
        <div class="menu-hider"></div>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import Navbar from '@/components/layouts/Navbar'

export default {
    name: 'EditInternalLink',
    components:{
        Navbar
    },
    data(){
        return {
            link:{},
            isAdmin: false,
            live: false,
            feedback: null,
            loading: false,
            loaded: false,
        }
    },
    methods:{
        newLink(){
            this.loading = true
            if(this.link.icon && this.link.link && this.link.title){
                this.feedback = null
                //create a slug
                let status
                if (this.live){
                    status = 'live'
                } else {
                    status = 'offline'
                }
                firebase.firestore().collection('dashboards').doc('internal').collection('links').add({
                    status,
                    title: this.link.title,
                    icon: this.link.icon,
                    link: this.link.link,
                }).then(() => {
                    this.feedback = 'The link has been added successfully'
                }).catch(err => {
                    this.feedback = err
                })
            } else {
                this.feedback = 'The icon, link and title fields are compulsory'
            }
            this.loading = false
        }
    }
}
</script>

<style>

</style>